"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocationOfNationalityProperty = exports.locationOfNationalityPropertyDefinition = void 0;
exports.locationOfNationalityPropertyDefinition = {
    view: { label: 'Nationality' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'stencils',
            argument: ['country', 'worldwide-geolocation'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'location-of-nationality',
};
const isLocationOfNationalityProperty = (prop) => {
    return prop.name === exports.locationOfNationalityPropertyDefinition.name;
};
exports.isLocationOfNationalityProperty = isLocationOfNationalityProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYXRpb24tb2YtbmF0aW9uYWxpdHkucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9sb2NhdGlvbi1vZi1uYXRpb25hbGl0eS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHVDQUF1QyxHQUFHO0lBQ3JELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxhQUFhLEVBQUU7SUFDOUIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxTQUFTLEVBQUUsdUJBQXVCLENBQUM7U0FDL0M7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUseUJBQXlCO0NBQ0EsQ0FBQTtBQUkxQixNQUFNLCtCQUErQixHQUFHLENBQUMsSUFBa0IsRUFBeUMsRUFBRTtJQUMzRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssK0NBQXVDLENBQUMsSUFBSSxDQUFBO0FBQ25FLENBQUMsQ0FBQTtBQUZZLFFBQUEsK0JBQStCLG1DQUUzQyJ9